import React from 'react'
import reactStamp from 'react-stamp'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import InfiniteCalendar from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css';
import './picker.css'

export default reactStamp(React).compose({

    init(){
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onOk = this.onOk.bind(this);
        this.state.date = this.props.onsetDate;
    },

    state: {
        open: false,
    },

    handleOpen(){
        this.setState({open: true});
    },

    onSelect(e){
        this.setState({date: (e.format('YYYY-MM-DD'))});
    },

    onOk(){
        this.props.onDateChange(this.state.date);
        this.setState({open: false});
    },

    handleClose(){
        this.setState({open: false});
    },

    render() {

        var today = new Date();

        const customContentStyle = {
            width: '348px',
            minHeight: '800px',
        };

        const actions = [
            <FlatButton
                label="Ok"
                primary={true}
                onTouchTap={this.onOk}
            />,

            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.handleClose}
            />,
        ];

        return (
            <div className="textfield-container">
                <TextField
                    className="textfield-date"
                    id="text-field-default"
                    value={this.props.onsetDate}
                    hintText="Select Date"
                    onFocus={this.handleOpen}
                />
                <Dialog
                    open={this.state.open}
                    contentStyle={customContentStyle}
                    modal={true}
                    onRequestClose={this.handleClose}
                    actions={actions}
                >
                    <InfiniteCalendar
                        theme={
                            {
                                selectionColor: '#0ca0d0',
                                textColor: {
                                    default: '#333',
                                    active: '#FFF'
                                },
                                weekdayColor: '#0CB2E3',
                                headerColor: '#0ca0d0',
                                floatingNav: {
                                    background: '#0ca0d0',
                                    color: '#FFF',
                                    chevron: '#FFF'
                                }
                            }
                        }
                        width={300}
                        height={330}
                        maxDate={today}
                        keyboardSupport={true}
                        onSelect={this.onSelect}
                    />
                </Dialog>
            </div>
        );
    }

});








/** WEBPACK FOOTER **
 ** ./src/app/components/DatePickerDialog/index.js
 **/